/** Ends the console session and returns the person to the sign-in page. */
export async function signOut(): Promise<void> {
  try {
    await fetch("/api/v1/auth/logout", { method: "POST", credentials: "same-origin" });
  } catch {
    // Navigate even if the logout call fails so the user is never trapped in the session.
  } finally {
    window.location.href = "/login";
  }
}
